<!-- =========================================================================================
  File Name: ExhibitorList.vue
  Description: Exhibitor List Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style lang="scss">
.header-custome {
  margin-bottom: 15px;
  padding-left: 2px;
}
.filterPhotowall {
  min-width: 220px;
}
.header-custome {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.knowlg-base-wrap-sec a {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 12px;
}
.knowlg-base-wrap-sec a span {
  margin-right: 10px;
  line-height: 0;
}
.header-custome {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.knowlg-base-wrap-sec a {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 12px;
}
.knowlg-base-wrap-sec a span {
  margin-right: 10px;
  line-height: 0;
}
.card-head-wrap{display: flex; justify-content: space-between;align-items: center;}
.card-head-left-wrap{display: flex; justify-content: flex-start; align-items: center;}
.carption-wrap {display: flex; justify-content: space-between; align-items: center;}
.filter-wrapper{display: flex; justify-content: flex-start; align-items: center;}
.single-chip{cursor: pointer;}
.filter-wrapper .single-chip .con-vs-chip{border-radius: 4px;}
.vx-card img.card-img-top{cursor: zoom-in;}
.resize-wrp{display: flex; justify-content: space-between; align-items: center;}
.h-full{height: 100%;}
.resize-wrp a {border: 1px solid #800080;color: #800080; padding: 3px 15px; border-radius: 4px; font-size: 13px;}
.check-box-wrap{display: flex; justify-content: flex-start;align-items: center;}
.dropdown_action_photowall .items-end {
    padding: .36em 0 !important;
    width: 88px !important;
}
.dropdown_action_photowall .items-end span {
    font-size: 13px;
}
</style>
<template>
  <div id="photowall-user-list">
    <div class="header-custome">
      <h3>Photo Wall</h3>
      <div class="knowlg-base-wrap-sec">
        <a href="/pages/knowledge-base/category-virtuallobby/question-2">
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-help-circle"
            >
              <circle cx="12" cy="12" r="10" />
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
              <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
          </span> Need help with this section?
        </a>
      </div>
    </div>
    <!-- <vx-card ref="filterCard" title="Filters" class="user-list-filters mb-8" actionButtons @refresh="resetColFilters" @remove="resetColFilters">
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Role</label>
          <v-select :options="roleOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="roleFilter" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Status</label>
          <v-select :options="statusOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="statusFilter" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Verified</label>
          <v-select :options="isVerifiedOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="isVerifiedFilter" class="mb-4 sm:mb-0" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Department</label>
          <v-select :options="departmentOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="departmentFilter" />
        </div>
      </div>
    </vx-card>-->

    <div class="vx-card p-6">
      <div class="card-head-wrap">
        <div class="card-head-left-wrap">
          Select Album &nbsp;
          <!-- <v-select
            class="mr-4 filterPhotowall"
            label="filterList"
            name="filterList"
            placeholder="Filter"
          />-->

          <v-select
            class="mr-4 filterPhotowall"
            name="photoDirectory"
            label="photoDirectory"
            v-model="preSelectedAlbum"
            :options="albumDropDown"
            @change="changeItem"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
          />

          <vs-button color="rgb(76, 139, 246)" type="filled" @click="addRecord2" class="mr-4">Upload</vs-button>
          Select All:<vs-checkbox class="filter-wrapper ml-4" @change="selectAll" v-model="allSelected" />
          <div class="filter-wrapper ml-4">
            <p class="mr-2">Filter:</p>
            <div class="single-chip" @click="filterData('All')">
              <vs-chip transparent :color="activechip == 'All' ? 'primary' : ''">
                All
              </vs-chip>
            </div>
            <div class="single-chip ml-2" @click="filterData('Publish')">
              <vs-chip transparent :color="activechip == 'Publish' ? 'success' : ''">
                Published
              </vs-chip>
            </div>
            <div class="single-chip ml-2"  @click="filterData('Unpublish')">
              <vs-chip transparent :color="activechip == 'Unpublish' ? 'warning' : ''">
                Unpublished
              </vs-chip>
            </div>
          </div>
        </div>
        <div class="flex flex-wrap items-center">
          <!-- ITEMS PER PAGE -->
          <div class="flex-grow"></div>
          <!--ADD -->
          <!-- <v-select class="mt-3"  v-model="data_local.PhotoScrollerRight" label="photoDirectory" name="PhotoScrollerRight" :options="photoWallList" :dir="$vs.rtl ? 'rtl' : 'ltr'" />  -->
          
          <vs-button class="mr-4" color="rgb(76, 139, 246)" type="filled" size="small" v-on:click="addRecord ()">Add Album</vs-button>
          <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
          <!-- <vs-input
            class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
            v-model="searchQuery"
            @input="updateSearchQuery"
            placeholder="Search..."
          />-->
          <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->
          <!-- ACTION - DROPDOWN -->
          <vs-dropdown vs-trigger-click class="cursor-pointer dropdown_action_photowall">
            <div
              class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32"
            >
              <span class="mr-2 leading-none">Actions</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item @click="changeStatus(true)">
                <span class="flex items-center">
                  <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Publish</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item @click="changeStatus(false)">
                <span class="flex items-center">
                  <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Unpublish</span>
                </span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="deleteRecord()">
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Delete</span>
                </span>
              </vs-dropdown-item>

              <!-- <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Archive</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Print</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>CSV</span>
                </span>
              </vs-dropdown-item>-->
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </div>
      <!-- AgGrid Table -->
      <!-- <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="photowallData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
      ></ag-grid-vue>-->
      <!--<ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="photowAlbumData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        :rowHeight="80"
      ></ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />-->
      
      <div class="card-wrapper mt-8">
        <div class="vx-row">
          <div class="vx-col w-full sm:w-1/4 lg:w-1/4 mb-base" v-for="row in photowallData">
              <vx-card class="h-full">
                <div slot="no-body">
                    <img :src="row.photoUrl" @click="popupActive2=true;popupImgSrc=row.photoUrl;popupTitle=row.docId" alt="content-img" class="responsive card-img-top">
                </div>
                <div class="carption-wrap">
                  <div class="caption-wrap-left">
                    <p class="mb-2 text-grey">{{ row.docId }}</p>
                    <p class="text-grey">{{ SetTimeByZone(new Date(row.LastModifiedDate.seconds * 1000).toUTCString(), Session_Event_TZ) }}</p>
                    <p>
                    
                    </p>
                  </div>
                  <div class="photowall-image-status">
                    <vs-chip transparent :color="row.IsPublished ? 'success' : 'warning'">
                      {{ row.IsPublished ? 'Published' : 'Unpublished' }}
                    </vs-chip>
                  </div>
                </div>
                <div class="resize-wrp mt-4">
                  <div class="check-box-wrap"><vs-checkbox :vs-value="row" v-model="checkedPhotoes" /><span>Select</span></div>
                  <router-link :to="{ name: 'photowall-resize', params: {row}}">Crop</router-link>
                </div>
              </vx-card>
          </div>
          <!--
          <div class="vx-col w-full sm:w-1/4 lg:w-1/4 mb-base">
              <vx-card>
                <div slot="no-body">
                    <img src="../../assets/images/slider/03.jpg" alt="content-img" class="responsive card-img-top">
                </div>
                <div class="carption-wrap">
                  <div class="caption-wrap-left">
                    <h5 class="mb-2">Test Image 2</h5>
                    <p class="text-grey">Test Subtitle Image</p>
                  </div>
                  <div class="photowall-image-status">
                    <vs-chip transparent color="warning">
                      Unpublished
                    </vs-chip>
                  </div>
                </div>
              </vx-card>
          </div>

          <div class="vx-col w-full sm:w-1/4 lg:w-1/4 mb-base">
              <vx-card>
                <div slot="no-body">
                    <img src="../../assets/images/slider/04.jpg" alt="content-img" class="responsive card-img-top">
                </div>
                <div class="carption-wrap">
                  <div class="caption-wrap-left">
                    <h5 class="mb-2">Test Image 3</h5>
                    <p class="text-grey">Test Subtitle Image</p>
                  </div>
                  <div class="photowall-image-status">
                    <vs-chip transparent color="success">
                      Published
                    </vs-chip>
                  </div>
                </div>
              </vx-card>
          </div>

          <div class="vx-col w-full sm:w-1/4 lg:w-1/4 mb-base">
              <vx-card>
                <div slot="no-body">
                    <img src="../../assets/images/slider/05.jpg" alt="content-img" class="responsive card-img-top">
                </div>
                <div class="carption-wrap">
                  <div class="caption-wrap-left">
                    <h5 class="mb-2">Test Image 4</h5>
                    <p class="text-grey">Test Subtitle Image</p>
                  </div>
                  <div class="photowall-image-status">
                    <vs-chip transparent color="warning">
                      Unpublished
                    </vs-chip>
                  </div>
                </div>
              </vx-card>
            </div>

            <div class="vx-col w-full sm:w-1/4 lg:w-1/4 mb-base">
              <vx-card>
                <div slot="no-body">
                    <img src="../../assets/images/slider/05.jpg" alt="content-img" class="responsive card-img-top">
                </div>
                <div class="carption-wrap">
                  <div class="caption-wrap-left">
                    <h5 class="mb-2">Test Image 4</h5>
                    <p class="text-grey">Test Subtitle Image</p>
                  </div>
                  <div class="photowall-image-status">
                    <vs-chip transparent color="warning">
                      Unpublished
                    </vs-chip>
                  </div>
                </div>
              </vx-card>
            </div>
            -->
        </div>
      </div>
    </div>

    <vs-popup fullscreen  class="holamundo" :title="popupTitle" :active.sync="popupActive2">
      <img v-show="popupImgSrc" :src="popupImgSrc" />
    </vs-popup>

  </div>
</template>
<script>
//import db from "@/firebase/firebaseInit.ts";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import moment from "moment-timezone";
import ls from "@/common/localStorage";

// Store Module
import modulePhotowallManagement from "@/store/photowall-management/modulePhotowallManagement.js";

// Cell Renderer
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
import CellRendererVerified from "./cell-renderer/CellRendererVerified.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";

//console.log(db);
var Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ");

export default {
  components: {
    AgGridVue,
    vSelect,
    selectedPhotoAlbumData: [],
    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions,
  },
  data() {
    return {
      card_1: {},
      popupImgSrc: null,
      popupTitle: null,
      popupActive2: false,
      Session_Event_TZ: Session_Event_TZ,
      preSelectedAlbum: "General",
      albumDropDown: [],
      checkedPhotoes:[],
      allSelected: false,
      // Filter Options
      roleFilter: { label: "All", value: "all" },
      roleOptions: [
        { label: "All", value: "all" },
        { label: "Admin", value: "admin" },
        { label: "User", value: "user" },
        { label: "Staff", value: "staff" },
      ],
      statusFilter: { label: "All", value: "all" },
      statusOptions: [
        { label: "All", value: "all" },
        { label: "Active", value: "active" },
        { label: "Deactivated", value: "deactivated" },
        { label: "Blocked", value: "blocked" },
      ],
      isVerifiedFilter: { label: "All", value: "all" },
      isVerifiedOptions: [
        { label: "All", value: "all" },
        { label: "Yes", value: "yes" },
        { label: "No", value: "no" },
      ],
      departmentFilter: { label: "All", value: "all" },
      departmentOptions: [
        { label: "All", value: "all" },
        { label: "Sales", value: "sales" },
        { label: "Development", value: "development" },
        { label: "Management", value: "management" },
      ],
      activechip: 'All',
      searchQuery: "",
      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      // columnDefs: [
      //   {
      //     //headerName: 'ID',
      //     //field: 'id',
      //     width: 55,
      //     checkboxSelection: true,
      //     headerCheckboxSelectionFilteredOnly: true,
      //     headerCheckboxSelection: true,
      //   },
      //   // {
      //   //   headerName: 'Photo',
      //   //   field: 'photourl',
      //   //   filter: true,
      //   //    width: 450,
      //   //   cellRendererFramework: 'CellRendererLink'
      //   // },
      //   {
      //     headerName: "Photo Album",
      //     field: "photoDirectory",
      //     filter: true,
      //     width: 280,
      //   },
      //   // {
      //   //   headerName: 'Likes',
      //   //   field: 'Likes',
      //   //   filter: true,
      //   //   width: 90
      //   // },
      //   {
      //     headerName: "Status",
      //     field: "Status",
      //     filter: true,
      //     width: 200,
      //   },
      //   {
      //     headerName: "Created Date",
      //     field: "CreatedDate",
      //     filter: true,
      //     width: 400,
      //   },
      //   // {
      //   //   headerName: 'Actions',
      //   //   field: 'transactions',
      //   //   width: 150,
      //   //   cellRendererFramework: 'CellRendererActions',
      //   //   cellRendererParams: (params) => {
      //   //     return {id : params.data.PhotowallId}
      //   //   }
      //   // }
      // ],
      columnDefs: [
        {
          headerName: "Image Name",
          field: "PhotoWallId",
          width: 300,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          pinned: "left",
        },
        {
          headerName: "Image",
          field: "photoUrl",
          filter: true,
          width: 300,
          pinned: "left",
          cellRendererFramework: "CellRendererLink",
        },

        {
          headerName: "Created By",
          field: "CreatedBy",
          filter: true,
          width: 200,
        },
        {
          headerName: "Created Date",
          field: "CreatedDate",
          filter: true,
          width: 200,
          cellRenderer: (data) => {
            return data.value.seconds
              ? new Date(data.value.seconds * 1000).toLocaleDateString()
              : "";
          },
        },
        {
          headerName: "Status",
          field: "IsPublished",
          filter: true,
          width: 100,
          cellRendererFramework: "CellRendererStatus",
        },
      ],
      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions,
      },
    };
  },
  watch: {
    roleFilter(obj) {
      this.setColumnFilter("role", obj.value);
    },
    statusFilter(obj) {
      this.setColumnFilter("status", obj.value);
    },
    isVerifiedFilter(obj) {
      const val =
        obj.value === "all" ? "all" : obj.value === "yes" ? "true" : "false";
      this.setColumnFilter("is_verified", val);
    },
    departmentFilter(obj) {
      this.setColumnFilter("department", obj.value);
    },
    preSelectedAlbum(val){
      this.changeItem()
    }
  },
  computed: {
    photowAlbumData() {
      return this.$store.state.photowallManagement.SelectedphotowAlbum;
    },
    photowallData() {
      // if (this.$store.state.photowallManagement.photowalls.length > 0) {
      //   this.preSelectedAlbum = this.$store.state.photowallManagement.photowalls[0];
      //   this.fetch_SelectedphotowAlbumData(
      //     this.preSelectedAlbum.photoDirectory
      //   );
      // }
      let photowalls = this.$store.state.photowallManagement.photowalls      
      return photowalls;
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  methods: {
    selectAll: function() {
            this.checkedPhotoes = [];
            if (this.allSelected) {
                this.photowallData.forEach(row => {
                    this.checkedPhotoes.push(row);
                })
            }
        },
    changeStatus(Status) {
      let selectedRows;
      selectedRows = this.checkedPhotoes;
      if (selectedRows.length) {
        this.$vs.loading();
        this.$store
          .dispatch("photowallManagement/changeStatus", {
            AlbumName: this.preSelectedAlbum,
            photoList: selectedRows,
            Status: Status,
          })
          .then((res) => {
            //alert(res.message)
            this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Status",
              text: Status ? "Photo Published successfully" : "Photo Unpublished successfully",
            });
            //this.gridApi.deselectAll();
            this.checkedPhotoes = [];
            this.$store.dispatch("photowallManagement/fetchPhotowalls", {status:this.activechip, directory:this.preSelectedAlbum})
            this.$vs.loading.close();
            this.allSelected = false
            /*this.$store.dispatch(
              "photowallManagement/fetchSinglePhotoAlbum",
              this.preSelectedAlbum.photoDirectory
            );*/
          })
          .catch((err) => {
            //console.error(err)
            this.$vs.loading.close();
            this.allSelected = false
          });
      } else {
        this.$vs.dialog({
          type: "alert",
          position: "top-center",
          color: "warning",
          title: "Status",
          text: "Please Select a Photo",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },
    fetch_SelectedphotowAlbumData(selectedAlbum) {
      this.$store
        .dispatch("photowallManagement/fetchSinglePhotoAlbum", selectedAlbum)
        .then((res) => {
          this.selectedPhotoAlbumData = res.data;
          // console.log(res.data);
          // this.selectedPhotoAlbumData = this.selectedPhotoAlbumData.filter(
          //   function (value) {
          //     return value.PhotoWallId != "";
          //   }
          // );
        });
    },
    changeItem() {
      debugger;
      // console.log(event.target.innerText);
      //this.fetch_SelectedphotowAlbumData(event.target.innerText);
      this.allSelected = false
      this.$vs.loading();
      this.$store.dispatch("photowallManagement/fetchPhotowalls", {status:this.activechip, directory:this.preSelectedAlbum}).then((res) => {
        this.$vs.loading.close();
      })
    },
    deleteRecord() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm Delete",
        text: `You are about to delete`,
        accept: this.deleteRecords,
        acceptText: "Delete",
      });
    },
    deleteRecords() {
      let selectedRows;
      //selectedRows = this.gridApi.getSelectedRows();
      selectedRows = this.checkedPhotoes;
      if (selectedRows.length) {
        this.$vs.loading();
        this.$store
          .dispatch("photowallManagement/removeMultiRecords", {
            AlbumName: this.preSelectedAlbum,
            photoList: selectedRows,
          })
          .then((res) => {
            //alert(res.message)
            this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Delete",
              text: res.message,
            });
            //this.gridApi.deselectAll();
            this.checkedPhotoes = [];
            this.$store.dispatch("photowallManagement/fetchPhotowalls", {status:this.activechip, directory:this.preSelectedAlbum})
            this.$vs.loading.close();
            this.allSelected = false
            /*this.$store.dispatch(
              "photowallManagement/fetchSinglePhotoAlbum",
              this.preSelectedAlbum.photoDirectory
            );*/
          })
          .catch((err) => {
            //console.error(err)
            this.$vs.loading.close();
            this.allSelected = false
          });
      } else {
        //alert("Please Select Recepient!");
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Recepient",
          text: "Please Select Record!",
          acceptText: "OK",
        });
      }
    },

    addRecord() {
      let photoDirectory = null;
      //this.$router.push(`/event/photowall/add/`+null)
      this.$router
        .push({
          name: "photowall-add",
          params: {
            directory: photoDirectory
          }
        })
    },
    addRecord2() {
      let photoDirectory = '';
      if(this.preSelectedAlbum)
      {
        photoDirectory = this.preSelectedAlbum
        this.$router
          .push({
            name: "photowall-add",
            params: {
              directory: photoDirectory
            }
          })
      }
      else
      {
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Upload",
          text: "Please Select Album!",
          acceptText: "OK",
        });
      }
    },
    // editRecord () {
    //   this.$router.push(`/event/exhibitor/add/${268}`).catch(() => {})
    // },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column);
      let modelObj = null;

      if (val !== "all") {
        modelObj = { type: "equals", filter: val };
      }

      filter.setModel(modelObj);
      this.gridApi.onFilterChanged();
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = {
        label: "All",
        value: "all",
      };

      this.$refs.filterCard.removeRefreshAnimation();
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    GetDateTimeFromSeconds(seconds) {
      var myDate = new Date(1000 * seconds);
      return myDate.toUTCString();
    },
    SetTimeByZone: function (strDateTime, timeZone) {
      var date = moment
        .tz(strDateTime, timeZone)
        .format("MMM DD, YYYY hh:mm A");
      return date;
    },
    filterData(status){
      this.allSelected = false
      this.$vs.loading();
      this.activechip = status
      this.$store.dispatch("photowallManagement/fetchPhotowalls", {status:this.activechip, directory:this.preSelectedAlbum})
      .then((res) => {
        this.$vs.loading.close();        
      })
    },
    getDirectories(){
      this.$store.dispatch("photowallManagement/fetchPhotowallDirectories").then((res) => {
        let photowalls = res
        this.albumDropDown = [...new Set(photowalls.map(item => item))];
      })
    }

  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }
    //this.fetch_SelectedphotowAlbumData(null);
  },
  created() {
    if (!modulePhotowallManagement.isRegistered) {
      this.$store.registerModule(
        "photowallManagement",
        modulePhotowallManagement
      );
      modulePhotowallManagement.isRegistered = true;
    }
    this.$store.dispatch("photowallManagement/fetchPhotowalls", {status:this.activechip, directory:this.preSelectedAlbum})
    this.getDirectories();
  },
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>